import './custom.js';
/* UTILITY */
import './utility/is-mobile';

/* FEATURES */
import '../features/packshot/scripts';
import '../features/testimonials/scripts';
import '../features/backInStock/scripts';
import '../features/checkoutConfirmationModal/scripts';
import '../features/mobileMenu/scripts';

import '../features/searchBar/scripts/predictive-search'
import '../features/searchBar/scripts';
import '../features/shippingProgressbar/srcipts';
import '../features/drawer/scripts';

import '../features/discountCode/scripts'

// SECTIONS
import '../sections/klub/main.js';

